import { ReactNode } from 'react'
import type { ParseKeys } from 'i18next'
import CommunityIcon from 'shared/icons/community-icon'
import CoursesIcon from 'shared/icons/courses-icon'
import HomeIcon from 'shared/icons/home-icon'
import type { UnauthorizedUser, UserInterface } from 'shared/types/user-interface'
import { getDashboardLink, getShowDashboardLink } from './utils'

export interface MenuItemConfigType {
  name: ParseKeys
  href: string | ((user: UnauthorizedUser | UserInterface) => string)
  icon: ReactNode
  shouldItemRender?: (user: UnauthorizedUser | UserInterface) => boolean
  dataTestId?: string
}

export const menuItemsConfig: MenuItemConfigType[] = [
  {
    name: 'header.nav.communities',
    href: '/community',
    icon: <CommunityIcon className="max-h-10 max-w-10 scale-95" />,
    dataTestId: 'header-nav-communities-button',
  },
  {
    name: 'header.nav.courses',
    href: '/school',
    icon: <CoursesIcon className="max-h-10 max-w-10 scale-[0.889]" />,
    dataTestId: 'header-nav-courses-button',
  },
  {
    name: 'header.nav.dashboard',
    href: user => getDashboardLink(user),
    icon: <HomeIcon className="max-h-10 max-w-10 scale-[.70]" />,
    shouldItemRender: user => getShowDashboardLink(user),
    dataTestId: 'header-nav-dashboard-button',
  },
]
